import { setTag } from '@sentry/react';

const useSentryTag = () => {
  const setWhmcsIdTag = (whmcsId: string) => {
    setTag('whmcs_id', whmcsId);
  };
  const setPageUrlTag = (url: string) => {
    setTag('url', url);
  };

  return {
    setWhmcsIdTag: setWhmcsIdTag,
    setPageUrlTag: setPageUrlTag,
  };
};

export default useSentryTag;
